import { React } from "react";
import "./Preloader.css";

export default function Preloader() {
 
  return (
    <div id="preloader">
      <div className="preloader">
        <h3>Rockst<span>Arjun</span></h3>
        <h3>Rockst<span>Arjun</span></h3>
      </div>
    </div>
  );
}
